/* eslint-disable prettier/prettier */
import React from "react";

const Delay = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.2554 5.42908H10.122C9.88736 5.42908 9.69531 5.23712 9.69531 5.00238C9.69531 4.76773 9.88728 4.57569 10.122 4.57569H11.8287V2.86908C11.8287 2.63443 12.0207 2.44238 12.2554 2.44238C12.4901 2.44238 12.6821 2.63435 12.6821 2.86908V5.00238C12.682 5.23713 12.49 5.42908 12.2554 5.42908Z"
      fill="#961B01"
    />
    <path
      d="M7.98817 13.5359C6.50765 13.5359 5.11457 12.9599 4.06703 11.9103C3.01747 10.8628 2.44141 9.46983 2.44141 7.98915C2.44141 6.50846 3.01738 5.11555 4.06703 4.06801C5.11453 3.01845 6.50749 2.44238 7.98817 2.44238C9.8079 2.44238 11.5765 3.32773 12.6005 4.75278C12.7392 4.94475 12.6944 5.21143 12.5024 5.34796C12.3104 5.48662 12.0437 5.4418 11.9072 5.24983C11.041 4.04458 9.53921 3.29582 7.98835 3.29582C5.4007 3.29582 3.2951 5.40145 3.2951 7.98908C3.2951 10.5767 5.40072 12.6823 7.98835 12.6823C10.576 12.6823 12.6816 10.5767 12.6816 7.98908C12.6816 7.5923 12.6325 7.19765 12.5344 6.81578C12.4746 6.58747 12.6133 6.35498 12.8416 6.29525C13.0699 6.23553 13.3024 6.37418 13.3621 6.60247C13.4773 7.05255 13.537 7.5198 13.537 7.98917C13.537 9.4697 12.9611 10.8628 11.9114 11.9103C10.8619 12.9598 9.4689 13.5358 7.98821 13.5358L7.98817 13.5359Z"
      fill="#961B01"
    />
    <path
      d="M10.1208 8.41394H8.84076C8.60611 8.41394 8.41406 8.22198 8.41406 7.98724C8.41406 7.75259 8.60603 7.56055 8.84076 7.56055H10.1208C10.3554 7.56055 10.5475 7.75251 10.5475 7.98724C10.5475 8.2219 10.3555 8.41394 10.1208 8.41394Z"
      fill="#961B01"
    />
    <path
      d="M7.98529 7.56183C7.75064 7.56183 7.55859 7.36987 7.55859 7.13513V4.57513C7.55859 4.34048 7.75056 4.14844 7.98529 4.14844C8.21994 4.14844 8.41199 4.3404 8.41199 4.57513V7.13513C8.41199 7.36979 8.21994 7.56174 7.98529 7.56174V7.56183Z"
      fill="#961B01"
    />
    <path
      d="M7.98703 9.27094C7.28086 9.27094 6.70703 8.69711 6.70703 7.99094C6.70703 7.28477 7.28086 6.71094 7.98703 6.71094C8.6932 6.71094 9.26703 7.28477 9.26703 7.99094C9.26703 8.69711 8.6932 9.27094 7.98703 9.27094ZM7.98703 7.56424C7.75238 7.56424 7.56033 7.7562 7.56033 7.99094C7.56033 8.22559 7.7523 8.41763 7.98703 8.41763C8.22168 8.41763 8.41373 8.22567 8.41373 7.99094C8.41373 7.75629 8.22168 7.56424 7.98703 7.56424Z"
      fill="#961B01"
    />
  </svg>
);

export default Delay;
